import { useTranslate } from '~src/main/context/localization';

type DisclaimerMessageProps = {
  message?: string;
};

export const DisclaimerMessage = ({ message }: DisclaimerMessageProps) => {
  const tICU = useTranslate();

  if (!message) {
    return null;
  }

  return <div css={styles.promptMessage}>{tICU(`widget.${message}`)}</div>;
};

const styles = {
  promptMessage: {
    display: 'flex',
    alignItems: 'center',
    padding: '16px',
    marginTop: '16px',
    marginBottom: '16px',
    height: '72px',
    fontVariationSettings: '"wght" 400',
    fontSize: '14px',
    lineHeight: '20px',
    backgroundColor: '#FFF9F0',
  },
};
